import { render, staticRenderFns } from "./create-pdf.vue?vue&type=template&id=48a46128&scoped=true"
import script from "./create-pdf.vue?vue&type=script&lang=js"
export * from "./create-pdf.vue?vue&type=script&lang=js"
import style0 from "./create-pdf.vue?vue&type=style&index=0&id=48a46128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a46128",
  null
  
)

export default component.exports